import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-black text-white border-t border-brand-olive/20">
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Company info */}
            <div className="md:col-span-2">
              <div className="mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_50a99d4b-16e5-4a25-a3c2-534efc6745c6/artifacts/9ur1riyu_d51c164a-21d7-4291-b45e-5c3d3e3a1260-1_all_5079.jpg" 
                  alt="JRT Chideme Media Logo" 
                  className="w-32 h-32 rounded-lg"
                />
              </div>
              <h3 className="text-xl font-bold mb-3">JRT Chideme Media</h3>
              <p className="text-white/70 mb-4 leading-relaxed">
                Empowering small businesses, freelancers, and independent creators 
                with accessible, creative, and results-driven marketing solutions.
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-white/70">
                  <MapPin className="w-4 h-4" />
                  <span className="text-sm">United Kingdom</span>
                </div>
                <div className="flex items-center gap-2 text-white/70">
                  <Phone className="w-4 h-4" />
                  <span className="text-sm">0799917033</span>
                </div>
                <div className="flex items-center gap-2 text-white/70">
                  <Mail className="w-4 h-4" />
                  <span className="text-sm">JRTChidemeMedia86@gmail.com</span>
                </div>
              </div>
            </div>
            
            {/* Quick links */}
            <div>
              <h4 className="text-lg font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#packages" className="text-white/70 hover:text-brand-yellow transition-colors duration-200">
                    Our Packages
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-white/70 hover:text-brand-yellow transition-colors duration-200">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white/70 hover:text-brand-yellow transition-colors duration-200">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white/70 hover:text-brand-yellow transition-colors duration-200">
                    Case Studies
                  </a>
                </li>
              </ul>
            </div>
            
            {/* Services */}
            <div>
              <h4 className="text-lg font-bold mb-4">Services</h4>
              <ul className="space-y-2">
                <li className="text-white/70 text-sm">Social Media Management</li>
                <li className="text-white/70 text-sm">Content Creation</li>
                <li className="text-white/70 text-sm">Ad Campaign Management</li>
                <li className="text-white/70 text-sm">Brand Strategy</li>
                <li className="text-white/70 text-sm">Website Design</li>
              </ul>
            </div>
          </div>
          
          {/* Social media & bottom bar */}
          <div className="border-t border-white/20 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-white/70 text-sm">
                © {currentYear} JRT Chideme Media. All rights reserved.
              </p>
              
              <div className="flex items-center gap-4">
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-brand-yellow rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-brand-yellow rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-brand-yellow rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <Twitter className="w-5 h-5" />
                </a>
                <a 
                  href="https://linkedin.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-brand-yellow rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
